export enum LogoutPopupPropsEnums {
  RIGHT = 'right',
  EMPTY_STRING = '',
  CLICK_TRIGGER = 'click',
  CHANGE_PASSWORD = 'Change Password',
  LOGOUT = 'Logout',
}
